import React from "react";
import "./Header.scss";

const Header = () => {
  return (
    <header className="Header">
      <h1>USA COVID-19 Map</h1>
      <h2>Click on a State to view individual COVID-19 data.</h2>
    </header>
  );
};

export default Header;
